<template>
  <a-card :bordered="false" :actionon="actionon">
    <!-- 顶部筛选区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="装卸货点编号">
              <a-input v-model.trim="queryParam.code" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="装卸货点名称">
              <a-input v-model.trim="queryParam.name" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="所属厂区">
                <a-select v-model="queryParam.factoryId" default-value="0" placeholder="请选择">
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in factorySelect"
                    :key="index"
                    :value="item.id"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="装卸货电状态">
                <a-select v-model="queryParam.status" default-value="0" placeholder="请选择">
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in statusSelect"
                    :key="index"
                    :value="item.value"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="装卸货点类型">
                <a-select v-model="queryParam.type" default-value="0" placeholder="请选择">
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in typeSelect"
                    :key="index"
                    :value="item.value"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="装卸货点优先级">
                <a-select v-model="queryParam.priority" default-value="0" placeholder="请选择">
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in prioritySelect"
                    :key="index"
                    :value="item.value"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
      <a-button
        type="dashed"
        v-if="config.hasAlert"
        @click="tableOption"
      >{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
    </div>

    <!-- 数据网格 -->
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x:1500 }"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多
            <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a @click="handleFactoryLoadPort(record)">料口管理</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="handleMateriel(record)">设置物料</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="handleDel(record)">删除</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>

    <a-modal
      title="编辑"
      style="top: 20px;"
      :width="560"
      v-model="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
    >
      <a-form :form="form">
        <a-form-item label="装卸货点编号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            v-model="mdl.code"
            placeholder="请输入装卸货点编号"
            v-decorator="['code',
            { initialValue: mdl.code, rules: [{ required: true, message: '请输入装卸货点编号'}]}]"
          />
        </a-form-item>

        <a-form-item label="装卸货点名称" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            v-model="mdl.name"
            placeholder="请输入装卸货点名称"
            v-decorator="['name',
            { initialValue: mdl.name, rules: [{ required: true, message: '请输入装卸货点名称'}]}]"
          />
        </a-form-item>

        <a-form-item label="所属厂区" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            v-model="mdl.factoryId"
            placeholder="请选择所属厂区"
            v-decorator="['factoryId',
            { initialValue: mdl.factoryId, rules: [{ required: true, message: '请选择所属厂区'}]}]"
          >
            <a-select-option
              v-for="(item, index) in factorySelect"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="装卸货点状态" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            v-model="mdl.status"
            placeholder="请选择装卸货点状态"
            v-decorator="['status',
            { initialValue: mdl.status, rules: [{ required: true, message: '请选择装卸货点状态'}]}]"
          >
            <a-select-option
              v-for="(item, index) in statusSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="装卸货点类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            v-model="mdl.type"
            placeholder="请选择装卸货点类型"
            v-decorator="['type',
            { initialValue: mdl.type, rules: [{ required: true, message: '请选择装卸货点类型'}]}]"
          >
            <a-select-option
              v-for="(item, index) in typeSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="装卸货点优先级" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            v-model="mdl.priority"
            placeholder="请选择装卸货点优先级"
            v-decorator="['priority',
            { initialValue: mdl.priority, rules: [{ required: true, message: '请选择装卸货点优先级'}]}]"
          >
            <a-select-option
              v-for="(item, index) in prioritySelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      title="设置物料"
      style="top: 80px;"
      :width="360"
      :heigh="720"
      v-model="materielModel"
      @ok="handleMaterielOk"
      :confirmLoading="confirmLoading"
    >
      <template>
        <a-select
          showSearch
          :filterOption="filterOption"
          mode="multiple"
          v-model="checkList"
          style="width: 100%"
          @change="handleChange"
          placeholder="请选择物料"
        >
          <a-select-option
            v-for="(item, index) in materielSelect"
            :key="index"
            :value="item.id"
          >{{item.name}}</a-select-option>
        </a-select>
      </template>
    </a-modal>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import {
  factoryLoadPage,
  factoryList,
  factoryLoadUpdate,
  factoryLoadSave,
  factoryLoadDelete,
  materielList,
  materielFindMaterielByFactoryLoad,
  factoryLoadSetMateriel
} from '../../api/basic'
import storage from '@/utils/storage'
import { getBizTextByValue } from '@/utils/util'
import { formatDate } from '@/utils/date'
export default {
  name: 'FactoryLoad',
  components: {
    STable
  },
  data() {
    return {
      pageSizeOptionsList:['10'],
      visible: false,
      confirmLoading: false,
      materielModel: false,
      checkList: [],
      // 强制渲染参数
      actionon: 1,
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},

      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' },
           width: '40px',
           fixed:"left"
        },
        {
          title: '装卸货点编号',
          dataIndex: 'code',
          width: '140px',
        },
        {
          title: '装卸货点名称',
          dataIndex: 'name',
          width: '140px',
        },
        {
          title: '所属厂区',
          dataIndex: 'factoryName',
          width: '100px',
        },
        {
          title: '状态',
          dataIndex: 'statusName',
          width: '100px',
        },
        {
          title: '类型',
          dataIndex: 'typeName',
          width: '100px',
        },
        {
          title: '优先级',
          dataIndex: 'priorityName',
          width: '100px',
        },
        {
          title: '吨位',
          dataIndex: 'tonnage',
          width: '100px',
        },
        {
          title: '创建人',
          dataIndex: 'createId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
         {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
         {
          title: '更新人',
          dataIndex: 'updateId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
        {
          title: '操作',
          width: '130px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed:"right"
        }
      ],

      // 所属厂区下拉
      factorySelect: null,
      // 状态下拉
      statusSelect: null,
      // 类型下拉
      typeSelect: null,
      // 优先级下拉
      prioritySelect: null,
      // 物料下拉
      materielSelect: null,

      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return factoryLoadPage(Object.assign(parameter, this.queryParam)).then(res => {
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: {
          show: false,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created() {
    this.tableOption()
    this.loadSelect()
  },
  methods: {
    loadSelect() {
      // 从后台拉去下拉列表数据
      new Promise(resolve => {
        const data = factoryList().then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.factorySelect = res
      })
      new Promise(resolve => {
        const data = materielList().then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        let nres = []
        res.forEach(item => {
          item.name = item.name + '(' + getBizTextByValue(this.$store.getters.bizList, item.businessTypeId) + ')'
          nres.push(item)
        })
        this.materielSelect = nres
      })
      this.statusSelect = this.$store.getters.codeList.basic_factory_load_status
      this.typeSelect = this.$store.getters.codeList.basic_factory_load_type
      this.prioritySelect = this.$store.getters.codeList.basic_factory_load_priority
    },
    filterOption(input, option) {
      // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleEdit(record) {
      this.mdl = Object.assign({}, record)
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleAdd() {
      this.mdl = {}
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          if (this.mdl.id !== undefined) {
            factoryLoadUpdate(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          } else {
            factoryLoadSave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          }
        }
      })
    },
    handleDel(record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk() {
          return factoryLoadDelete({ ids: record.id })
            .then(res => {
              if (res.code === '0') {
                nthis.$refs.table.refresh()
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {})
        },
        onCancel() {}
      })
    },
    handleFactoryLoadPort(record) {
      storage.save('cache-FactoryLoadPort', JSON.stringify(record))
      this.$router.push({ name: 'FactoryLoadPort' })
    },
    handleMateriel(record) {
      this.checkList.length = 0
      this.mdl = Object.assign({}, record)
      let nthis = this
      materielFindMaterielByFactoryLoad({ factoryLoadId: this.mdl.id }).then(res => {
        let ids = new Array()
        for (let i = 0; i < res.data.length; i++) {
          ids.push(res.data[i].materielId)
        }
        nthis.checkList = ids
        nthis.actionon++
        nthis.materielModel = true
      })
    },
    handleMaterielOk() {
      let materiels = ''
      for (let i = 0, len = this.checkList.length; i < len; i++) {
        if (this.checkList[i] != undefined) {
          materiels += this.checkList[i] + ','
        }
      }
      materiels = materiels.substring(0, materiels.length - 1)
      factoryLoadSetMateriel({ factoryLoadId: this.mdl.id, materiels: materiels })
        .then(res => {
          this.$message.success('设置成功')
        })
        .catch(() => {})
        .finally(() => {
          this.form = this.$form.createForm(this)
          this.materielModel = false
        })
    },
    handleChange(value) {
      this.checkList = value
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    }
  }
}
</script>
